// Pure port of the combo drill-down scope: the qs{key} param round-trip that lived in
// combo/block.coffee, and the answer / answer-variant walk plus word derivation that
// lived in Combo.Lib. OeDispatcher.jsx carried its own copy of the walk for the headless
// PPTX path; it now imports from here so there is one implementation.
import { noTextPlaceholder, removeLogicFromText } from '@aytm/app/stats/page/components/lib/utils'

// '*' means "stop here, show this level" -- it terminates the walk without drilling.
export const ROOT_SCOPE = '*'

export const resolveAnswer = (scope = [], answer) => {
  let current = answer

  for (const s of scope) {
    if (ROOT_SCOPE === s) break
    if (null == current?.[`a${s}`]) return { total: 0 }
    current = current[`a${s}`]
  }

  return current
}

export const resolveAnswerVariants = (scope = [], avs = []) => {
  let current = avs

  for (const s of scope) {
    if (ROOT_SCOPE === s) break
    current = current?.[s - 1]?.answerVariants || []
  }

  return current
}

// A drill level is kept only while the answer still carries it; the first level that no
// longer resolves truncates the scope, so a stale param degrades instead of breaking.
export const parseScope = (param, answer) => {
  const scope = [ROOT_SCOPE]
  if (null == param) return scope

  const parts = 'string' === typeof param ? param.split('-') : param

  for (let i = 0; i < parts.length; i++) {
    const s = parts[i]
    if (null == s) break

    const level = parseInt(s, 10)
    if (Number.isNaN(level)) {
      scope[i] = s
      continue
    }

    if (null == resolveAnswer(parts.slice(0, i), answer)?.[`a${level}`]) break
    scope[i] = level
  }

  return scope
}

// Serializes back to the param, or null when the scope is still at the root level.
export const serializeScope = (scope = []) => {
  const levels = scope.filter(s => null != s)
  if (!levels.length || Number.isNaN(parseInt(levels[0], 10))) return null

  return levels.join('-')
}

// [text, weight, position] triples for the word cloud: per-variant cloudWords on a
// multi-level question, plain variant amounts otherwise.
export const calcWords = (levels, scope, answer, answerVariants) => {
  const scopedAnswer = resolveAnswer(scope, answer)
  const scopedAvs = resolveAnswerVariants(scope, answerVariants)

  const words = []

  if (!scopedAvs?.length && scopedAnswer?.cloudWords) {
    for (const w of scopedAnswer.cloudWords.words) words.push([w[0], w[1], 0])
  } else {
    for (const av of scopedAvs || []) {
      const avAnswer = av && scopedAnswer?.[`a${av.position}`]
      if (null == avAnswer) continue

      if (levels > 1 && avAnswer.cloudWords) {
        for (const w of avAnswer.cloudWords.words) words.push([w[0], w[1], av.position])
      } else {
        words.push([removeLogicFromText(av.text) || noTextPlaceholder(av), avAnswer.amount, av.position])
      }
    }
  }

  return words.filter(v => v[0] && 0 < v[0].length)
}
